import { MessageSquare, Sparkles, TrendingUp } from 'lucide-react';

import type { TemplateAr } from '../../template-data';

export const automateUpSellsFromSupportTicketsAr: TemplateAr = {
  name: 'أتمتة فرص البيع الإضافي من تذاكر الدعم بالذكاء الاصطناعي',
  description:
    'ارصد فرص البيع الإضافي أثناء محادثات الدعم وحوّلها لإيراد فعلي. يتكامل مباشرة مع نظام التذاكر عندك.',
  category: 'المبيعات والتواصل',
  workflow: [
    { icon: MessageSquare, label: 'الدعم' },
    { icon: Sparkles, label: 'الـ AI يرصد' },
    { icon: TrendingUp, label: 'بيع إضافي', final: true },
  ],
  detailDescription: {
    paragraph1:
      'ارصد فرص البيع الإضافي والمتقاطع وهي تصير، داخل محادثة الدعم نفسها. وبينما يحل فريقك أسئلة العملاء، الـ AI يقرأ سياق المحادثة — أنماط استخدام المنتج، وطلبات الميزات، ونقاط الألم، ومستوى الحساب — عشان يعرف متى يستفيد العميل فعلاً من ترقية أو إضافة أو ميزة متقدمة. وبعدها إما يعرض الفرصة على الموظف لحظياً، أو يقدّم العرض للعميل تلقائياً. أنت اللي تحدد.',
    paragraph2:
      'الفرص توصل للأدوات اللي تفضّلها — تنبيه Slack لفريق المبيعات، أو تحديث CRM لتتبّع خط المبيعات، أو تصدير Excel/CSV لتقارير الإيراد الأسبوعية. ووش ما كان المكان اللي يحتاجه فريقك، الفرصة توصل له. وبيانات التحويل وتتبّع الإسناد تتزامن مع أنظمة التقارير اللي عندك أصلاً.',
  },
  benefits: [
    'حوّل محادثة الدعم لفرصة إيراد',
    'إشارة الترقية تطلع لك لحظياً',
    'بلا عروض بيع محرجة. الـ AI يعرف اللحظة المناسبة.',
    'تعرف أي تفاعل دعم درّ إيراداً فعلاً',
    'الفرصة توصل لفريق المبيعات لمّا تحتاج',
    'القيمة الدائمة للعميل ترتفع، بلا جهد إضافي على فريقك',
  ],
};
